import { DOM_IDS, DOM_CLASS_NAMES, HS_INPUT_CHAR_LIMIT } from 'CmsManagePreferences/utils/constants';
import { addClass, removeClass } from 'CmsManagePreferences/utils/manageClass';
import { setDisabledById, setDisplayById, sanitizeText } from 'CmsManagePreferences/utils/common';
import { submitSurvey } from 'CmsManagePreferences/api/survey';
import { getRedirectUrl, redirectToUrl, getLanguageCodeFromUrl, getQueryParams } from 'CmsManagePreferences/utils/url';
import { PAGE_TYPE } from 'CmsManagePreferences/utils/constants';
export default function unsubscribeSurveyListeners() {
  setupRadioButtonListeners();
  otherReasonListeners();
  surveyFormSubmitListeners();
}
export function setupRadioButtonListeners() {
  document.querySelectorAll('input[name="unsubscribe-reason"]').forEach(function (radio) {
    radio.addEventListener('change', () => {
      setDisabledById(DOM_IDS.unsubscribeSurveySubmitButton, false);
      setDisplayById(DOM_IDS.unsubscribeSurveyFormControl, 'none');
    });
  });
  const otherRadio = document.getElementById(DOM_IDS.unsubscribeOtherOption);
  if (otherRadio) {
    otherRadio.addEventListener('change', event => {
      const radioElement = event.currentTarget;
      if (!radioElement) {
        return;
      }
      if (radioElement.checked) {
        setDisabledById(DOM_IDS.unsubscribeSurveySubmitButton, true);
        setDisplayById(DOM_IDS.unsubscribeSurveyFormControl, 'block');
      }
    });
  }
}
export function otherReasonListeners() {
  const otherInput = document.getElementById(DOM_IDS.unsubscribeSurveyOtherInput);
  if (otherInput) {
    otherInput.addEventListener('input', () => {
      const trimmedValue = otherInput.value.trim();
      if (trimmedValue.length > HS_INPUT_CHAR_LIMIT) {
        setDisabledById(DOM_IDS.unsubscribeSurveySubmitButton, true);
        setDisplayById(DOM_IDS.otherInputErrorLabel, 'block');
        addClass(otherInput, DOM_CLASS_NAMES.inputError);
      } else if (trimmedValue.length === 0) {
        setDisabledById(DOM_IDS.unsubscribeSurveySubmitButton, true);
        setDisplayById(DOM_IDS.otherInputErrorLabel, 'none');
      } else {
        setDisabledById(DOM_IDS.unsubscribeSurveySubmitButton, false);
        setDisplayById(DOM_IDS.otherInputErrorLabel, 'none');
        removeClass(otherInput, DOM_CLASS_NAMES.inputError);
      }
    });
  }
}
export function surveyFormSubmitListeners() {
  const surveyForm = document.getElementById(DOM_IDS.unsubscribeSurvey);
  if (surveyForm) {
    surveyForm.addEventListener('submit', event => {
      event.preventDefault();
      const selectedRadio = document.querySelector('input[name="unsubscribe-reason"]:checked');
      const selectedValue = selectedRadio ? selectedRadio.value : null;
      const dataParam = getQueryParams('data');
      if (!selectedValue || !dataParam) {
        return;
      }
      let otherReason = null;
      if (selectedValue === 'OTHER') {
        const otherInput = document.getElementById(DOM_IDS.unsubscribeSurveyOtherInput);
        otherReason = otherInput ? sanitizeText(otherInput.value) : null;
      }
      const language = getLanguageCodeFromUrl();
      const payload = {
        reasonCode: selectedValue,
        reasonOtherText: otherReason,
        language
      };
      submitSurvey(payload, dataParam).then(() => {
        setDisplayById(DOM_IDS.emailPlaceholder, 'none');
        setDisplayById(DOM_IDS.confirmationMessage, 'none');
        setDisplayById(DOM_IDS.unsubscribeSurvey, 'none');
        setDisplayById(DOM_IDS.surveySubmitSuccessMessage, 'block');
      }).catch(() => {
        redirectToUrl(getRedirectUrl(PAGE_TYPE.failure));
      });
    });
  }
}